import { heroImage, type LandingPage } from "@/lib/data/landing/types"

// TODO(photo): MIU in-house shoot needed for the brunch items with no photo
// yet: Breakfast Sandwich, Breakfast BurriTUS, Take Ur Seat Salad, Longanisa
// Rice Bowl, RenDaang Beef Curry Bowl, Hot Chick Rice Bowl, Tofu Mushroom
// Bowl, TUS Style Musubi, TUS Style Fries. Plated, overhead or 45 degrees, 4:5
// portrait. Add each to toast-menu-images.ts under the item's exact Toast name.
export const BRUNCH_PAGE: LandingPage = {
  path: "/brunch",
  breadcrumb: "Breakfast & Brunch",
  title: "Breakfast & Brunch in Rancho Cucamonga | +Bake Cafe",
  description:
    "Breakfast sandwiches, avocado toast, Filipino-style rice bowls and TUS Spam musubi, served daily until 2 PM at +Bake Cafe on Base Line Rd, Rancho Cucamonga.",
  eyebrow: "From the kitchen",
  h1: "Breakfast and Brunch at +Bake Cafe",
  intro:
    "+Bake is the bakery cafe from the Take Ur Seat brunch family, so the kitchen cooks like one. Rice bowls with longanisa and pork belly, a breakfast sandwich on brioche, avocado toast, and the TUS-style Spam musubi regulars keep ordering. The kitchen takes orders from 7:30 AM to 2 PM every day. Pastries and coffee run until 3:30 PM.",
  hero: heroImage(
    "brunch-hero",
    "Belly 2 Belly Rice Bowl with grilled pork belly, scrambled egg and cucumber tomato salad",
  ),
  trackingLocation: "brunch_page",
  sections: [
    {
      id: "plates",
      heading: "Brunch plates",
      paragraphs: [
        "Four plates for a sit-down breakfast. The breakfast sandwich comes with fries, and the BurriTUS comes with your choice of fries or salad.",
      ],
      items: [
        { name: "Avocado Bacon Toast", image: "/images/plusbake/menu/avocado-toast.webp" },
        { name: "Breakfast Sandwich" },
        { name: "Breakfast BurriTUS" },
        { name: "Take Ur Seat Salad" },
      ],
    },
    {
      id: "rice-bowls",
      heading: "Rice bowls",
      paragraphs: [
        "Rice bowls are the part of the menu that comes straight from Take Ur Seat. Each one is steamed rice, scrambled egg and a protein, with cucumber tomato salad on most. The Belly 2 Belly is the signature: grilled pork belly with Take Ur Seat's own sauce.",
        "Beyond the five below, the kitchen also makes the Belly On Fire (roasted pork belly with TUS hot sauce), the Sweet Chick and the Spam Rice Bowl, all $15.95.",
      ],
      items: [
        { name: "Belly 2 Belly Rice Bowl", image: "/images/plusbake/menu/belly-2-belly-bowl.webp" },
        { name: "Longanisa Rice Bowl" },
        { name: "RenDaang Beef Curry Bowl" },
        { name: "Hot Chick Rice Bowl" },
        { name: "Tofu Mushroom Bowl" },
      ],
    },
    {
      id: "quick-bites",
      heading: "Quick bites",
      paragraphs: [
        "Smaller plates for sharing or for adding to a coffee order. The TUS-style musubi uses a thick cut of grilled Spam with spicy mayo, and it's the one people come back for.",
      ],
      items: [
        { name: "Spam Musubi", image: "/images/plusbake/menu/spam-musubi.webp" },
        { name: "TUS Style Musubi" },
        { name: "TUS Style Fries" },
        { name: "Longanisa Roll (3)", label: "Longanisa Roll" },
      ],
    },
    {
      id: "grab-and-go",
      heading: "Grab and go",
      paragraphs: [
        "If you're on your way somewhere, skip the kitchen line. The Egg-Cellent Sando, the salt bread sandwiches and the chilled cups are ready in the case.",
      ],
      items: [
        { name: "Egg-Cellent Sando" },
        { name: "That OatLyfe", label: "Overnight Oats (That OatLyfe)" },
        { name: "Berry Chia Pudding" },
      ],
      links: [{ label: "The salt bread sandwiches", to: "salt-bread" }],
    },
    {
      id: "kitchen-hours",
      heading: "Kitchen hours",
      paragraphs: [
        "The café is open 7:30 AM to 3:30 PM, but the hot kitchen stops taking orders at 2:00 PM. Rice bowls, plates, musubi and fries are made to order, so they're only available until then, in the café and on Toast.",
        "After 2 PM the pastry case, the grab-and-go case and the full drinks menu are still available until we close at 3:30 PM. If you're planning a late brunch, order ahead on Toast before 2 PM and pick it up when you get here.",
      ],
      links: [{ label: "Hours & directions", to: "visit" }],
    },
    {
      id: "take-ur-seat",
      heading: "From Take Ur Seat",
      paragraphs: [
        "+Bake grew out of Take Ur Seat, the brunch restaurant family that started in Chino Hills. The rice bowls, the TUS sauces and the Spam musubi on this menu come from that side of the family.",
      ],
      links: [{ label: "Our family story", to: "about" }],
    },
  ],
  faq: [
    {
      q: "What time does the kitchen close?",
      a: "Hot food orders are taken until 2:00 PM daily. Pastries and drinks are available until 3:30 PM.",
    },
    {
      q: "Do you take reservations?",
      a: "No. Seating is first come, first served. You can also order ahead on Toast for pickup.",
    },
    {
      q: "Do you have vegetarian options?",
      a: "Yes, including the Tofu Mushroom Bowl, avocado toast (ask for no bacon), overnight oats, and chia pudding.",
    },
    {
      q: "Is +Bake related to Take Ur Seat?",
      a: "Yes. +Bake is the bakery of the Take Ur Seat family, which also runs brunch restaurants in Chino Hills, Ontario, Pomona, and Redlands.",
    },
  ],
}
